<script lang="ts">
  import { onMount, setContext } from "svelte";
  import { fade } from "svelte/transition";
  import CanvasFreeDrawing from "./ts/free-draw";
  import print from "print-js";

  import {
    scaleToFit,
    loadImage,
    scaleToFill,
    drawImageOriginalSize,
  } from "./ts/image";
  import Icon from "svelte-awesome";
  import { faPalette } from "@fortawesome/free-solid-svg-icons/faPalette";
  import {
    faUpload,
    faPaintRoller,
    faSave,
    faPrint,
  } from "@fortawesome/free-solid-svg-icons";

  import { ctrolDisplayFlag } from "./store";
  import { hexToArray, rgba2hex } from "./ts/utils";
  import Draggable from "./Dragger.svelte";
  import Controls from "./Controls.svelte";

  var isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);
  /**
   *---------------
   *  Image source to load
   */
  export let src: string;

  let controls;

  let btnScale = 2;

  let currentColor = "#ab47bc";

  let isVisibleControls = false;

  /* For loading images*/
  let promise;

  // to store image url from input text.
  let imageSource = null;

  let cfd, w;

  let canvas;

  setContext("paint", {
    getCfd: () => cfd,
  });

  /**
   * Paint the image on the screen
   *
   */

  function paint(canvas: HTMLCanvasElement, image) {
    drawImageOriginalSize(canvas, image, w);

    cfd = new CanvasFreeDrawing({
      canvas,
      width: canvas.width,
      height: canvas.height,
      lineWidth: 20,
      bucketToolTolerance: 30,
      strokeColor: currentColor,
    });
  }

  function toggle() {
    controls.style.display =
      controls.style.display === "block" ? "none" : "block";
  }

  onMount(() => {
    if (src) {
      promise = loadImage(src);
    }
  });

  function download() {
    var link = document.createElement("a");
    link.download = "pixobe.png";

    addAccredition();

    link.href = canvas.toDataURL();
    link.click();
    link.delete;
  }

  function print_canvasr() {
    addAccredition();
    print({
      printable: canvas.toDataURL(),
      type: "image",
      imageStyle: "width:100%",
    });
  }

  function addAccredition() {
    var context = canvas.getContext("2d");

    context.font = "bold 26px Helvetica, Arial, sans-serif";
    const w= context.canvas.width;
    const h= context.canvas.height;
    context.fillStyle = "#5d5d5d";
    context.fillText("www.pixobe.com", w/2-20, 40);

    context.fillStyle = "#ffffff";
    context.fillText("www.pixobe.com", w/2-20, h-40);
  }

  function readFile(event) {
    let file = event.target.files[0];

    let reader = new FileReader();

    var img = new Image();

    reader.onload = function () {
      var img = new Image();
      img.onload = () => {
        promise = new Promise((res, rej) => {
          // dummy fix
          return res(img);
        });
      };
      img.src = src = reader.result;
    };

    reader.onerror = function () {
      alert("Sorry, unable to read the image.");
    };

    reader.readAsDataURL(file);
  }

  function loadImageFromSource() {
    if (!imageSource) {
      alert("Please input a valid image url.");
    }
    src = imageSource;
    promise = loadImage(imageSource);
  }
</script>

<style lang="scss">
  @import "scss/main";
</style>

{#if !src}
  <div class="file-upload">
    <form>
      <div class="file-uploader">
        <label>
          <div class="form-label">
            <div>
              <Icon data={faUpload} scale="3" />
            </div>
            <div>Upload Image</div>
          </div>
          <input type="file" on:change={readFile} />
        </label>
      </div>
      <div class="m3"><span>OR</span></div>
      <div class="input-group">
        <input
          type="text"
          placeholder="Paste image URL here."
          bind:value={imageSource} />
        <button type="button" on:click={loadImageFromSource}>
          <Icon data={faPaintRoller} scale="1" />
        </button>
      </div>
    </form>
  </div>
{/if}
{#if promise}
  <div class="drawing-board" bind:clientWidth={w}>
    {#await promise}
      <p>Loading image please wait...</p>
    {:then image}
      <canvas use:paint={image} bind:this={canvas} />
      {#if cfd}
        <p class="buttons has-background-white">
          <button class="button" on:click={toggle}>
            <span class="icon">
              <Icon data={faPalette} scale={btnScale} />
            </span>
          </button>
          <button class="button" on:click={download}>
            <span class="icon">
              <Icon data={faSave} scale={btnScale} />
            </span>
          </button>
          <button class="button" on:click={print_canvasr}>
            <span class="icon">
              <Icon data={faPrint} scale={btnScale} />
            </span>
          </button>
        </p>
        <div class="controls-wrapper" transition:fade bind:this={controls}>
          <Draggable>
            <Controls on:message={toggle} />
          </Draggable>
        </div>
      {/if}
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
  </div>
{/if}
